import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { getCookieChoice, setCookieChoice } from '../utils/analytics';

// Shoppers need to be able to read these before choosing
const READABLE_PAGES = ['/cookie', '/privacy', '/privacy-policy', '/terms'];

const CookieConsent = () => {
    const { pathname } = useLocation();
    const [open, setOpen] = useState(() => !getCookieChoice());

    const choose = (accepted) => {
        setCookieChoice(accepted);
        setOpen(false);
    };

    return (
        <Modal
            show={open && !READABLE_PAGES.includes(pathname.toLowerCase())}
            onHide={() => choose(false)}
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>Cookie Policy</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                We use cookies to improve your experience on our site and to show you personalized advertising.
                By accepting, you agree to our use of cookies as described in our <Link to="/cookie">Cookie Policy</Link>.
            </Modal.Body>
            <Modal.Footer>
                <Button style={{ backgroundColor: '#3E6D9C', borderColor: '#FD7014' }} onClick={() => choose(true)}>
                    Accept
                </Button>
                <Button style={{ backgroundColor: '#FD7014', borderColor: '#3E6D9C' }} onClick={() => choose(false)}>
                    Reject
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CookieConsent;
